import { getBrand } from "./brandHelper";

export const getEnvVar = (key) => {
  const brand = getBrand();

  // Try brand-specific variable first
  const brandSpecificKey = `VITE_${brand.toUpperCase()}_${key}`;
  if (import.meta.env[brandSpecificKey]) {
    return import.meta.env[brandSpecificKey];
  }

  // Fallback to default variable
  return import.meta.env[key];
};

export const getApiUrl = () => getEnvVar("VITE_ONBOARDING_API_URL");
export const getChatUrl = () => getEnvVar("VITE_ONBOARDING_CHAT_URL");
export const getPaletteUrl = () => getEnvVar("VITE_ONBOARDING_PALETTE_URL");
export const getUnsplashUrl = () => getEnvVar("VITE_UNSPLASH_URL");
export const getUnsplashClientId = () => getEnvVar("VITE_UNSPLASH_CLIENT_ID");
export const getLoginUrl = () => getEnvVar("VITE_LOGIN_URL");
export const getCreateSiteWizardUrl = () =>
  getEnvVar("VITE_CREATE_SITE_WIZARD_URL");
export const getUpdateSiteWizardUrl = () =>
  getEnvVar("VITE_UPDATE_SITE_WIZARD_URL");
export const getGeneratePageDataUrl = () =>
  getEnvVar("VITE_GENERATE_PAGE_DATA_URL");
export const getCreateProjectUrl = () => getEnvVar("VITE_CREATE_PROJECT_URL");
export const getSfcoreUrl = () => getEnvVar("VITE_SFCORE_URL");
export const getProjectsTokenUrl = () => getEnvVar("VITE_PROJECTS_TOKEN_URL");
export const getGetLoginUrl = () => getEnvVar("VITE_GET_LOGIN_URL");
export const getIds4UjwtUrl = () => getEnvVar("VITE_IDS4_UJWT_URL");
export const getImageMfeUrl = () => getEnvVar("VITE_IMAGE_MFE_URL");
export const getProjectLimitsUrl = () => getEnvVar("VITE_PROJECT_LIMITS");
export const getFullstoryUrl = () => getEnvVar("VITE_FULLSTORY_URL");
export const getLoginRedirectUrl = () => getEnvVar("VITE_LOGIN_REDIRECT_URL");
export const getSfcoreAccessKey = () => getEnvVar("VITE_SFCORE_ACCESS_KEY");
export const getSfcoreAccessKeyDomains = () =>
  getEnvVar("VITE_SFCORE_ACCESS_KEY_DOMAINS");
export const getCheckGridLayoutUrl = () => getEnvVar("VITE_CHECK_GRID_LAYOUT");
export const getOnboardingProgressUrl = () =>
  getEnvVar("VITE_ONBOARDING_PROGRESS_URL");
export const getDomaincomDashboardPrefix = () =>
  getEnvVar("VITE_DOMAINCOM_DASHBOARD_URL_PREFIX");
export const getWebcomDashboardPrefix = () =>
  getEnvVar("VITE_WEBCOM_DASHBOARD_URL_PREFIX");
export const getAiTonesUrl = () => getEnvVar("VITE_ONBOARDING_PROGRESS_URL");
export const getNetsolDashboardPrefix = () =>
  getEnvVar("VITE_NETWORKSOLUTIONS_DASHBOARD_URL_PREFIX");
export const getProvisionedResourcesUrl = () =>
  getEnvVar("VITE_PROVISIONED_RESOURCES_URL");
export const getSinglePageRenderUrl = () =>
  getEnvVar("VITE_SINGLE_PAGE_RENDER_URL");
export const getFosApiKey = () => getEnvVar("VITE_FOS_API_KEY");
export const getStudioApiUrl = () =>
  getEnvVar("VITE_STUDIO_API_URL") ||
  "https://api-gw.uat.builderservices.io/ss-api/v1.0";
export const getImageLibraryUrl = () => getEnvVar("VITE_IMAGE_LIBRARY_URL");
export const getSfAmUrl = () => getEnvVar("VITE_SFAM_URL");
export const getSfamToken = () => getEnvVar("VITE_SFAM_TOKEN");
export const getSiteplusAccountsMfeUrl = () =>
  getEnvVar("VITE_SITEPLUS_ACCOUNT_MFE");
